export default "__VITE_ASSET__126697ef__"